import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import type { APIError } from '@vizit/auth';
import { disconnectAmazonVendorConnectionV1IntegrationsAmazonVendorConnectionsIntegrationIdDelete } from '../../generated';
import type { DisconnectAmazonVendorConnectionV1IntegrationsAmazonVendorConnectionsIntegrationIdDeleteData } from '../../generated';

export type DisconnectAmazonVendorMutationVariables =
  DisconnectAmazonVendorConnectionV1IntegrationsAmazonVendorConnectionsIntegrationIdDeleteData['path'];

export type DisconnectAmazonVendorMutation = undefined;

export const DISCONNECT_AMAZON_VENDOR_ERROR_CODE = {
  OrgAdminRequired: 'ORG_ADMIN_REQUIRED',
  NotFound: 'RETAILER_INTEGRATION_NOT_FOUND',
  CredentialsDeleteFailed: 'CREDENTIALS_DELETE_FAILED',
} as const;

export const useDisconnectAmazonVendorMutation = <TError = APIError, TContext = unknown>(
  options?: Omit<
    UseMutationOptions<DisconnectAmazonVendorMutation, TError, DisconnectAmazonVendorMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<DisconnectAmazonVendorMutation, TError, DisconnectAmazonVendorMutationVariables, TContext>({
    mutationKey: ['DisconnectAmazonVendor'],
    mutationFn: async ({ integration_id }) => {
      await disconnectAmazonVendorConnectionV1IntegrationsAmazonVendorConnectionsIntegrationIdDelete({
        path: { integration_id },
        throwOnError: true,
      });
      return undefined;
    },
    ...options,
  });
};
